/// <amd-module name="Artifacts/Upack/commands/PermanentDelete" />
import { getPermanentDeleteCommandCreator } from "Artifacts/Root/protocols/Commands";
import { UpackActions } from "Artifacts/Upack/redux";

export const createPermanentDeleteCommand = getPermanentDeleteCommandCreator(
  UpackActions.permanentDelete,
);
